import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isModalVisible: false,
  modalData: null
}

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isModalVisible = true
      state.modalData = action.payload
    },
    dismissModal: state => {
      state.isModalVisible = false
      state.modalData = null
    }
  }
})

// Export the auto-generated action creators
export const { openModal, dismissModal } = modalSlice.actions

// Export the reducer to include in your store
export default modalSlice.reducer
